import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { IoMdCheckmarkCircle } from "react-icons/io";
import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';
import { motion, AnimatePresence } from 'framer-motion';
import Marquee from 'react-fast-marquee';


import logo from '../../../assets/farmHouse/logo.png'
import hero1 from '../../../assets/farmHouse/hero1.jpeg'
import hero2 from '../../../assets/farmHouse/hero2.jpg'
import hero3 from '../../../assets/farmHouse/hero3.webp'
import hero4 from '../../../assets/farmHouse/hero4.jpg'
import ph1 from "../../../assets/farmHouse/ph1.jpg";
import ph2 from "../../../assets/farmHouse/ph2.jpg";
import ph3 from "../../../assets/farmHouse/ph3.jpg";
import ph4 from "../../../assets/farmHouse/ph4.jpg";
import ph5 from "../../../assets/farmHouse/ph5.jpg";

import li1 from "../../../assets/farmHouse/li1.webp";
import li2 from "../../../assets/farmHouse/li2.jpg";
import li3 from "../../../assets/farmHouse/li3.jpg";
import li4 from "../../../assets/farmHouse/li4.jpeg";
import li5 from "../../../assets/farmHouse/li5.jpg";
import ImageSwiper from '../../common/ImageSwiper';

const imgUrl = process.env.REACT_APP_IMAGEURL

const LakeViewFarms = () => {

    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);
    const [index, setIndex] = useState(0);

    const [selectedImgIndex, setSelectedImgIndex] = useState(null);
    const [activeImageType, setActiveImageType] = useState(null);
    
    const images = [hero1, hero2, hero3, hero4];

    // const ameneties = [ph1, ph2, ph3, ph4, ph5]

    const interiors = [li1, li2, li3, li4, li5]

    const ameneties = [
        { id: 0, img: ph1, title: "Secure Gated Community" },
        { id: 1, img: ph2, title: "Lush Green Gardens" },
        { id: 2, img: ph3, title: "Wide Internal Roads" },
        { id: 3, img: ph4, title: "Outdoor Sports Facility" },
        { id: 4, img: ph5, title: "Internal Street Light" },
    ]


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);


    const handleOpenModal = (index, type) => {
        setSelectedImgIndex(index);
        setActiveImageType(type);
        setOpenImgModal(true);
    };

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <ImageSwiper images={images}/>
            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="relative w-full sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] aspect-[16/9] overflow-hidden rounded-lg">
                    <img
                        src={logo}
                        alt="logo"
                        className="absolute top-0 left-0 w-full h-full object-cover"
                    />
                </div>
            </div>



            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                A true symbol of exclusivity, farmhouses in prime locations—like those near metropolitan areas or
                                scenic landscapes—are now significant investments in the real estate market. Whether you're
                                looking for relaxation or planning future developments, owning a farmhouse unlocks a world of
                                luxurious possibilities.   </p>
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                Sector 156 in Noida is home to some of the most luxurious natural farmhouse projects, offering a
                                serene and upscale lifestyle. These farmhouses are designed to blend modern amenities with the
                                tranquility of nature, making them an ideal choice for those seeking a peaceful yet sophisticated
                                living experience.                             </p>

                            <h2 className="text-2xl md:text-3xl font-bold my-2">Key Features</h2>
                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">1. Prime Location:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Situated near the TCS Campus, these farmhouses boast excellent
                                        connectivity to commercial hubs, schools, hospitals, and the Noida Expressway.
                                    </p>
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">2. Spacious Plots:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The farmhouses come in various sizes, ranging from 1250 sq. yards to 5000
                                        sq. yards, providing ample space for privacy and luxury.
                                    </p>
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">3. Natural Beauty:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The projects feature lush greenery, manicured lawns, tranquil ponds, and
                                        even an expansive artificial lake, creating a refreshing and picturesque environment.
                                    </p>
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">4. Modern Amenities:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Residents can enjoy state-of-the-art facilities such as swimming pools,
                                        gyms, cycling tracks, kids' play areas, and clubhouses.
                                    </p>
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">5. Recreational Spaces:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The farmhouses include cricket pitches, golf courses, and open-air
                                        sports amenities, catering to an active lifestyle.
                                    </p>
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">6. Eco-Friendly Design:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        With features like rainwater collection systems and verdant garden
                                        spaces, these projects emphasize sustainability.
                                    </p>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h2 className="text-2xl md:text-3xl font-bold my-2">Accessibility</h2>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The location is highly accessible, with proximity to key landmarks
                                    </p>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-medium">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            2-minute drive from North India’s Largest TCS Campus.                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            2-minute drive from Republic Bharat News Campus.
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            5-minute drive from Noida Expressway.
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            15-minute drive from Noida Sector-147 Metro Station.
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            25-minute drive from Yatharth Super Specialty Hospital.
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h2 className="text-2xl md:text-3xl font-bold my-2">Lifestyle Benefits
                                    </h2>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Living in these farmhouses offers a unique blend of luxury and nature. The serene environment is
                                        perfect for relaxation, while the modern amenities ensure convenience and comfort. Whether you're
                                        hosting events, enjoying outdoor activities, or simply unwinding by the lake, these farmhouses
                                        provide an unparalleled living experience.                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 m-4">
                Projects Highlights
            </h2>
            {openImgModal && activeImageType === "ameneties" && (
                <ImageModal
                    images={ameneties}
                    openImg={openImgModal}
                    selectedImgIndex={selectedImgIndex}
                    onClose={() => setOpenImgModal(false)}
                />
            )}

            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 px-4">
                {ameneties.map((data, index) => (
                    <div key={index}
                        onClick={() => handleOpenModal(index, "ameneties")}
                        className="w-full max-w-sm mx-auto rounded-md shadow-md overflow-hidden bg-white">
                        <div className="relative">
                            <img
                                src={data.img}
                                alt={data.title}
                                className="w-full h-56 object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                        <div className="px-5 py-3">
                            <h3 className="text-gray-700 font-semibold">{data.title}</h3>
                        </div>
                    </div>
                ))}
            </div>

            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                    Develop Dreams
                </h2>

                {openImgModal && activeImageType === "interiors" && (
                    <ImageModal
                        images={interiors}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {interiors.map((data, index) => (
                        <div
                            key={index}
                            onClick={() => handleOpenModal(index, "interiors")}
                            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                        >
                            <img
                                src={data}
                                alt="ATS"
                                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                    ))}
                </div>

            </div>
        </div>
    )
}
export default LakeViewFarms;